import type { Game } from '../types/Game';

import { scalePrizeValue } from './sortGames';

const getTopPrizeGame = (games: Game[]): Game | undefined =>
  games.reduce((topGame: Game | undefined, currentGame) => {
    if (currentGame.promoRef !== '') return topGame;

    const currentGamePrizeValue = scalePrizeValue(currentGame.winUpTo);
    if (!topGame) return currentGame;

    const topGamePrizeValue = scalePrizeValue(topGame.winUpTo);

    return currentGamePrizeValue > topGamePrizeValue ? currentGame : topGame;
  }, undefined);

export default getTopPrizeGame;
